module.exports = __webpack_public_path__ + "fonts/Inter-LightItalic.adc7017.woff2";